import React from 'react';
import SectionHeader from './ui/SectionHeader';

const MODES = [
  {
    title: 'Verified publicly',
    badge: 'Public badge',
    description:
      'For people comfortable showing a visible badge. Profile photos are matched with a live selfie and liveness check — so others know photos are really them.',
    accent: 'border-primary/30 bg-primary/10',
  },
  {
    title: 'Verified discreetly',
    badge: 'Discreet badge',
    description:
      'For people who want stronger trust without putting verification on display. Identity checks are completed privately — profile photos aren’t used in the match.',
    accent: 'border-secondary/30 bg-secondary/10',
  },
];

function WhyVerification() {
  return (
    <section className="relative overflow-hidden py-24 md:py-32">
      <div className="pointer-events-none absolute right-0 top-1/3 h-80 w-80 rounded-full bg-primary/10 blur-[100px]" aria-hidden />

      <div className="site-container relative">
        <SectionHeader
          tag="Trust without forcing visibility"
          title="Why two ways"
          titleAccent="to verify?"
          description="Not everyone in the queer community can safely be publicly visible. Privacy should never mean less safety."
        />

        <div className="grid gap-4 lg:grid-cols-2">
          {MODES.map((mode) => (
            <article key={mode.title} className={`glass-card-hover rounded-3xl border p-8 ${mode.accent}`}>
              <span className="mb-4 inline-block rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-bold uppercase tracking-wider text-accent">
                {mode.badge}
              </span>
              <h3 className="mb-3 text-xl font-bold text-white">{mode.title}</h3>
              <p className="text-sm leading-relaxed text-silver">{mode.description}</p>
            </article>
          ))}
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-sm leading-relaxed text-mist md:text-base">
          Tap any badge in the app to see exactly what it means. You can be verified and still choose not
          to show a badge — because visibility should always be your choice.
        </p>
      </div>
    </section>
  );
}

export default WhyVerification;
